import type { State } from '../../Slice/index.js'
import type { ISpinStatusEntry } from '../../Slice/Spin/SpinStatusSlice.ts'

const IDLE: ISpinStatusEntry = { status: 'idle', watchers: 0 }

/** The cached SPIN state of a scope; `idle` when it was never requested. */
export const selectSpinStatus =
  (scopeId: string | null | undefined) =>
  (state: typeof State): ISpinStatusEntry =>
    (scopeId && state.spinStatus.byScope[scopeId]) || IDLE
